/* ==========================================================================
   TUYO — Monte seu Kit: barra de compra / orquestrador

   Não desenha picker nenhum. Cada passo é uma seção `section-product` do tema
   na MESMA página (mesmo DOM, sem iframe e sem injeção), então este arquivo só
   lê a variante escolhida em cada uma e monta o carrinho.

   Gravação = o personalizador PRÓPRIO da Tuyo (snippet flask-configurator,
   `window.TuyoGravacao`). Ele nasce no form da garrafa e é realocado pro card
   do passo 2; quando há gravação, é ele quem adiciona a garrafa (com a prévia
   `Personalização` e os links do arquivo de gravação), já na variante gêmea e
   com o `_bundle_id` do kit. Nada do Zepto.

   Todos os itens são obrigatórios (4, ou 5 com a BottleBag): o desconto do kit
   só vale com o kit fechado.
   ========================================================================== */
(function () {
  'use strict';

  /* Marcador de deploy: o CDN serve este arquivo MINIFICADO (comentários somem),
     então procurar comentário pra saber se subiu dá falso negativo. Bater esta
     string é o jeito confiável. Subir junto a cada mudança. */
  var TB_BUILD = 'kit-2026-09-30-ordem-bolsa-3';
  window.__TUYO_KIT_BUILD = TB_BUILD;

  function money(cents, format) {
    var value = (cents || 0) / 100;
    var fmt = format || 'R$ {{amount_no_decimals}}';

    function group(thousands, decimal, decimals) {
      var parts = value.toFixed(decimals).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? int + decimal + parts[1] : int;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(',', '.', 2);
        case 'amount_no_decimals': return group(',', '.', 0);
        case 'amount_with_comma_separator': return group('.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group('.', ',', 0);
        default: return group(',', '.', 2);
      }
    });
  }

  /* A loja formata em R$ SEM decimais. Num kit com 30% os valores caem em
     centavos (R$ 146,30 / 27,30 / 22,40 / 18,90) e, arredondados na exibição,
     as partes deixam de bater com o total (146+27+22+19=214 vs R$ 215).
     Aqui mostramos os centavos SÓ quando existem — assim a conta fecha na tela
     e continua igual ao resto do site nos valores redondos. */
  function moneyKit(cents, format) {
    if (!cents || cents % 100 === 0) return money(cents, format);
    var withDecimals = (format || '').replace(
      /amount_no_decimals(_with_comma_separator)?/,
      'amount_with_comma_separator'
    );
    return money(cents, withDecimals);
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function json(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || 'Erro no carrinho');
        return body;
      });
    });
  }

  function sleep(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  /* Incantação validada no Palo Alto (base Impact). */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    window.setTimeout(function () {
      if (document.body.classList.contains('js-drawer-open-cart')) return;
      var cart = document.querySelector('#cart-drawer, cart-element[data-cart-drawer], [data-cart-drawer]');
      if (cart && typeof cart.openCartDrawer === 'function') cart.openCartDrawer();
      else document.body.classList.add('js-drawer-open-cart');
    }, 400);
  }

  function init(root) {
    if (root.__tbInit) return;
    root.__tbInit = true;

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-tb-data]').textContent);
    } catch (err) {
      console.error('[tuyo-bundle] JSON da seção inválido', err);
      return;
    }

    var fmt = data.moneyFormat;
    /* Quantos itens fecham o kit: 4, e 5 quando a página tem o passo da
       BottleBag. Tem que bater com o `min_lines` do metafield da Function. */
    var required = data.keys.bag ? 5 : 4;
    var pct = Number(data.discountPct) || 0;
    var fullBase = data.priceBase === 'full';

    /* Base do desconto.
       - 'sale' (cupom): kit = venda − pct%; riscado = venda.
       - 'full' (Function): kit = cheio − pct%, nunca acima da venda; riscado = cheio.
         Se a promoção já está abaixo de cheio−pct%, o item fica no preço de venda
         (desconto zero naquela linha) — é exatamente o que a Function cobra. */
    function baseOf(price, compare) {
      if (fullBase && compare > price) return compare;
      return price;
    }
    function kitPrice(price, compare) {
      var base = baseOf(price, compare);
      var target = pct > 0 ? Math.round(base * (100 - pct) / 100) : base;
      return Math.min(price, target);
    }

    /* Auto-scroll: guarda o valor de cada passo pra detectar ESCOLHA do cliente
       (e não o primeiro desenho da página, que não deve rolar nada). */
    var lastValues = {};
    var booted = false;
    var scrollTimer = null;

    var chipsWrap = root.querySelector('[data-tb-chips]');
    var totalEl = root.querySelector('[data-tb-total]');
    var compareEl = root.querySelector('[data-tb-compare]');
    var saveEl = root.querySelector('[data-tb-save]');
    var addBtn = root.querySelector('[data-tb-add]');
    var addLabel = root.querySelector('[data-tb-add-label]');
    var errorEl = root.querySelector('[data-tb-error]');
    var progressEl = root.querySelector('[data-tb-progress]');
    var noteEl = root.querySelector('[data-tb-note]');
    var addLabelText = addLabel.textContent;

    /* Nota do cupom: só faz sentido quando há código pra aplicar. */
    if (noteEl && data.discountCode && data.discountNote) {
      noteEl.textContent = data.discountNote.replace('{code}', data.discountCode);
      noteEl.hidden = false;
    }

    /* ── achar cada form na página pela CHAVE da seção ─────────────────── */

    /* Em template JSON o id vira `template--<n>__<chave>`, então casamos pelo sufixo. */
    function sectionOf(key) {
      if (!key) return null;
      return document.querySelector('[data-section-id$="__' + key + '"]');
    }

    function formOf(key) {
      var section = sectionOf(key);
      return section ? section.querySelector('form.shopify-product-form') : null;
    }

    function variantOf(key) {
      var form = formOf(key);
      if (!form) return null;
      var input = form.querySelector('[name="id"]');
      var value = input ? Number(input.value) : null;
      return value || null;
    }

    function capButton() {
      return document.querySelector('[data-tb-cap][aria-pressed="true"]:not([disabled])');
    }

    function chosen() {
      var out = [];

      var bottle = variantOf(data.keys.bottle);
      if (bottle) out.push({ key: 'Garrafa', id: bottle });

      var cap = capButton();
      if (cap) {
        out.push({
          key: 'Tampa',
          id: Number(cap.getAttribute('data-tb-cap')),
          override: {
            name: cap.getAttribute('data-tb-cap-name'),
            twin: Number(cap.getAttribute('data-tb-cap-twin')) || 0,
            price: Number(cap.getAttribute('data-tb-cap-price')),
            compare: Number(cap.getAttribute('data-tb-cap-compare')) || 0,
            img: (cap.querySelector('img') || {}).src
          }
        });
      }

      /* ordem (30/09/2026): garrafa · tampa · BottleBag · BottleSleeve · stickers */
      if (data.keys.bag) {
        var bag = variantOf(data.keys.bag);
        if (bag) out.push({ key: 'BottleBag', id: bag });
      }

      var sleeve = variantOf(data.keys.sleeve);
      if (sleeve) out.push({ key: 'Sleeve', id: sleeve });

      var sticker = variantOf(data.keys.sticker);
      if (sticker) out.push({ key: 'Stickers', id: sticker });

      return out.map(function (item) {
        var v = item.override || data.variants[item.id] || {};
        return {
          key: item.key,
          id: item.id,
          name: v.name,
          size: v.size,
          twin: v.twin || 0,
          price: v.price || 0,
          compare: v.compare || 0,
          img: v.img,
          available: v.available !== false
        };
      });
    }

    /* Cabeçalho de passo e form do produto são SEÇÕES separadas do Shopify.
       Carimbamos classes nos wrappers `.shopify-section` pra o CSS costurar as
       duas num card só. Só classe: mover seção no DOM quebra o editor. */
    function pairGroups() {
      root.ownerDocument.querySelectorAll('[data-tb-step-for]').forEach(function (head) {
        /* o passo da gravação já é um card inteiro (`.tb__perso`); carimbar o
           wrapper dele como "head" criava borda dupla e um vão extra em cima */
        if (head.classList.contains('tb__perso')) return;
        var key = head.getAttribute('data-tb-step-for');
        var headWrap = head.closest('.shopify-section');
        if (headWrap) headWrap.classList.add('tb__group--head');

        var body = document.querySelector('[data-section-id$="__' + key + '"]')
          || document.querySelector('[data-tb-step-body="' + key + '"]');
        var bodyWrap = body ? body.closest('.shopify-section') : null;
        if (bodyWrap) bodyWrap.classList.add('tb__group--body');
      });
    }

    /* O snippet do personalizador cria o `#flask-configurator` (e o botão
       estático `#flask-placeholder`, que segura o lugar até o React chegar)
       DENTRO do form da garrafa. Aqui os dois são REALOCADOS pro card do passo
       "Personalize". O React não liga pra onde o container mora, e o painel lê
       a variante e a galeria por seletor global — a 1ª garrafa da página, que
       é a do kit. Fora do form, Enter no texto também não envia nada. */
    function movePersonalizer() {
      var slot = document.querySelector('[data-tb-perso-slot]');
      if (!slot) return;

      var panel = document.getElementById('flask-configurator');
      if (!panel) return;

      var placeholder = document.getElementById('flask-placeholder');
      if (placeholder && !slot.contains(placeholder)) slot.appendChild(placeholder);
      if (slot.contains(panel)) return;

      var loading = slot.querySelector('[data-tb-perso-loading]');
      if (loading) loading.remove();
      slot.appendChild(panel);
    }

    function engraving() {
      return window.TuyoGravacao || null;
    }

    /* Preço do item já com o desconto do kit, com o cheio riscado ao lado.
       Cada passo mostra o SEU preço — sem isso o cliente só via o total. */
    function fillPrice(node, cents, compare) {
      if (!node) return;
      node.innerHTML = '';
      if (cents == null) return;
      if (!cents) {
        node.appendChild(el('span', 'tb__stepPrice__now', 'Grátis'));
        return;
      }
      var base = baseOf(cents, compare || 0);
      var net = kitPrice(cents, compare || 0);
      node.appendChild(el('span', 'tb__stepPrice__now', moneyKit(net, fmt)));
      if (net < base) {
        node.appendChild(el('s', 'tb__stepPrice__was', moneyKit(base, fmt)));
        /* etiqueta em cada linha: o % REAL sobre o preço riscado */
        var off = Math.round((1 - net / base) * 100);
        if (off > 0) node.appendChild(el('span', 'tb__stepPrice__off', off + '% OFF'));
      }
    }

    /* Preenche o estado de cada passo: OBRIGATÓRIO → ✓ com a opção escolhida. */
    function paintStep(key, value, price, compare) {
      var head = document.querySelector('[data-tb-step-for="' + key + '"]');
      if (!head) return;
      var required = head.querySelector('[data-tb-step-required]');
      var done = head.querySelector('[data-tb-step-done]');
      var slot = head.querySelector('[data-tb-step-value]');
      var ok = !!value;
      if (required) required.hidden = ok;
      if (done) done.hidden = !ok;
      if (slot) slot.textContent = value || '';
      if (price !== undefined) fillPrice(head.querySelector('[data-tb-step-price]'), price, compare);
    }

    /* As linhas da Tampa vêm do Liquid com o preço CHEIO; aqui viram o de kit. */
    function paintCapPrices() {
      document.querySelectorAll('[data-tb-cap]').forEach(function (btn) {
        var node = btn.querySelector('.tb__option__price');
        if (!node) return;
        fillPrice(node, Number(btn.getAttribute('data-tb-cap-price')), Number(btn.getAttribute('data-tb-cap-compare')) || 0);
      });
    }

    /* ── resumo ───────────────────────────────────────────────────────── */

    function render() {
      var items = chosen();
      var full = 0;
      var net = 0;
      /* Soma item a item JÁ arredondado, em vez de arredondar o total: é assim
         que o Shopify aplica % (por linha), e é o que o cliente confere somando
         os preços dos passos. Arredondar o total dava 1 real de diferença. */
      items.forEach(function (i) {
        full += baseOf(i.price, i.compare);
        net += kitPrice(i.price, i.compare);
      });

      totalEl.textContent = moneyKit(net, fmt);
      if (full - net > 0) {
        compareEl.hidden = false;
        compareEl.textContent = moneyKit(full, fmt);
        saveEl.hidden = false;
        saveEl.textContent = 'Você economiza ' + moneyKit(full - net, fmt);
      } else {
        compareEl.hidden = true;
        saveEl.hidden = true;
      }

      chipsWrap.innerHTML = '';
      items.forEach(function (i) {
        var li = el('li', 'tb__chip');
        if (i.img) {
          var img = el('img');
          img.src = i.img;
          img.alt = '';
          img.loading = 'lazy';
          li.appendChild(img);
        }
        li.appendChild(el('span', null, i.key + ' '));
        li.appendChild(el('b', null, i.name || ''));
        chipsWrap.appendChild(li);
      });

      var byKey = {};
      items.forEach(function (i) { byKey[i.key] = i; });

      var bottle = byKey['Garrafa'];
      paintStep(
        data.keys.bottle,
        bottle ? (bottle.size ? bottle.size + ' · ' + bottle.name : bottle.name) : null,
        bottle ? bottle.price : null,
        bottle ? bottle.compare : 0
      );
      paintStep('gravacao', engravingLabel(), 0);
      paintStep('caps', byKey['Tampa'] ? byKey['Tampa'].name : null, byKey['Tampa'] ? byKey['Tampa'].price : null, byKey['Tampa'] ? byKey['Tampa'].compare : 0);

      var values = {};
      values[data.keys.bottle] = bottle ? bottle.name : null;
      values['caps'] = byKey['Tampa'] ? byKey['Tampa'].name : null;
      values[data.keys.sleeve] = byKey['Sleeve'] ? byKey['Sleeve'].name : null;
      values[data.keys.sticker] = byKey['Stickers'] ? byKey['Stickers'].name : null;
      if (data.keys.bag) values[data.keys.bag] = byKey['BottleBag'] ? byKey['BottleBag'].name : null;
      maybeAdvance(values);
      paintStep(data.keys.sleeve, byKey['Sleeve'] ? byKey['Sleeve'].name : null, byKey['Sleeve'] ? byKey['Sleeve'].price : null, byKey['Sleeve'] ? byKey['Sleeve'].compare : 0);
      paintStep(data.keys.sticker, byKey['Stickers'] ? byKey['Stickers'].name : null, byKey['Stickers'] ? byKey['Stickers'].price : null, byKey['Stickers'] ? byKey['Stickers'].compare : 0);
      if (data.keys.bag) paintStep(data.keys.bag, byKey['BottleBag'] ? byKey['BottleBag'].name : null, byKey['BottleBag'] ? byKey['BottleBag'].price : null, byKey['BottleBag'] ? byKey['BottleBag'].compare : 0);

      /* kit fechado = todos os itens; sem isso o desconto não se justifica */
      addBtn.disabled = items.length < required;

      if (progressEl) {
        var done = items.length >= required;
        progressEl.textContent = done ? '✓ Kit completo' : items.length + ' de ' + required;
        progressEl.classList.toggle('tb__barProgress--done', done);
      }
    }

    /* Os pickers do tema mudam o `[name="id"]` sem evento próprio, então
       observamos o DOM em vez de tentar adivinhar o evento certo. */
    function watch() {
      ['bottle', 'sleeve', 'sticker', 'bag'].forEach(function (which) {
        var form = formOf(data.keys[which]);
        if (!form) return;
        form.addEventListener('change', render, true);
        new MutationObserver(render).observe(form, {
          subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'class']
        });
      });

      /* O personalizador vive num card próprio (fora dos forms), então precisa
         do seu próprio observador — senão o ✓ do passo de gravação nunca acende. */
      var slot = document.querySelector('[data-tb-perso-slot]');
      if (slot) {
        slot.addEventListener('change', render, true);
        slot.addEventListener('input', render, true);
        new MutationObserver(function () { window.setTimeout(render, 80); }).observe(slot, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class']
        });
      }

      /* O bloco `siblings` linka pra PDP crua do irmão — clicar em 1.2L jogaria
         o cliente PRA FORA do kit. Cada tamanho tem sua própria página de kit
         (mesma receita das LPs por litragem), então reescrevemos o destino. */
      routeSizeLinks();

      document.addEventListener('click', function (event) {
        var cap = event.target.closest ? event.target.closest('.tb__option[data-tb-cap]') : null;
        if (cap && !cap.disabled) {
          document.querySelectorAll('[data-tb-cap]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === cap));
          });
        }
        window.setTimeout(render, 120);
      }, true);
    }

    function routeSizeLinks() {
      var pages = {};
      (data.bottlePages || '').split(',').forEach(function (pair) {
        var parts = pair.split(':');
        var handle = (parts[0] || '').trim();
        var path = (parts.slice(1).join(':') || '').trim();
        if (handle && path) pages[handle] = path;
      });
      if (!Object.keys(pages).length) return;

      var section = sectionOf(data.keys.bottle);
      if (!section) return;

      function patch() {
        section.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          if (a.dataset.tbRouted) return;
          var handle = (a.getAttribute('href') || '').split('/products/')[1];
          if (!handle) return;
          handle = handle.split('?')[0].split('#')[0];
          var page = pages[handle];
          if (!page) return;

          /* preview_theme_id só enquanto o tema é draft; ao publicar sai limpo */
          var theme = window.Shopify && window.Shopify.theme;
          if (theme && theme.role !== 'main') {
            page += (page.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + theme.id;
          }
          a.setAttribute('href', page);
          a.dataset.tbRouted = '1';
        });
      }

      patch();
      new MutationObserver(patch).observe(section, { childList: true, subtree: true });
    }

    /* Rótulo do passo de gravação: o modo escolhido, e o texto quando houver.
       Só acende o ✓ quando a gravação está PRONTA (confirmada) — começada e
       incompleta não conta. */
    function engravingLabel() {
      var g = engraving();
      if (!g || !g.iniciado || !g.pronto) return null;
      var label = g.modo || 'Com gravação';
      if (g.texto) label += ' · ' + g.texto;
      return label;
    }

    /* Depois de escolher, leva o cliente pro passo seguinte — fecha o passo
       anterior visualmente e evita que ele "perca" o próximo na rolagem.
       Ordem fixa: garrafa → gravação → tampa → bolsa → sleeve → stickers → barra. */
    function stepOrder() {
      var order = [data.keys.bottle, 'gravacao', 'caps'];
      if (data.keys.bag) order.push(data.keys.bag);
      order.push(data.keys.sleeve, data.keys.sticker);
      return order;
    }

    function nextTarget(key) {
      var order = stepOrder();
      var i = order.indexOf(key);
      if (i === -1) return null;
      for (var j = i + 1; j < order.length; j++) {
        var el = document.querySelector('[data-tb-step-for="' + order[j] + '"]');
        if (el) return el;
      }
      return root; /* último passo → a barra de compra */
    }

    function scrollToStep(key) {
      var target = nextTarget(key);
      if (!target) return;
      /* desconta o header fixo do tema, senão o cabeçalho do passo fica escondido */
      var header = document.querySelector('.site-header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 12;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    /* Um passo só "avança" quando o valor MUDA por escolha do cliente. */
    function maybeAdvance(values) {
      if (!booted) {
        lastValues = values;
        booted = true;
        return;
      }
      var changed = null;
      Object.keys(values).forEach(function (key) {
        /* a gravação tem vários campos: rolar no meio dela atrapalharia */
        if (key === 'gravacao') return;
        if (values[key] && values[key] !== lastValues[key]) changed = key;
      });
      lastValues = values;
      if (!changed) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () { scrollToStep(changed); }, 260);
    }

    /* ── carrinho ─────────────────────────────────────────────────────── */

    /* Duas vias, na ordem:
       1) `/cart/update.js` com `discount` — aplica no CARRINHO, então o drawer
          e a página do carrinho já mostram o preço com os 30%;
       2) `/discount/CODE` — só grava o cookie que o checkout lê. Fica como
          rede de segurança se a via 1 não pegar (loja/API sem suporte).
       O desconto é acessório: nunca derruba o add. */
    function applyDiscount() {
      var code = data.discountCode;
      if (!code) return Promise.resolve();
      var byCookie = function () {
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .catch(function () {});
      };
      return json('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (cart) {
        var codes = cart.discount_codes || [];
        var applied = codes.some(function (d) {
          return String(d.code).toUpperCase() === code.toUpperCase() && d.applicable !== false;
        });
        if (!applied) return byCookie();
      }).catch(byCookie);
    }

    function fail(message) {
      errorEl.hidden = false;
      errorEl.textContent = message;
      addLabel.textContent = addLabelText;
      addBtn.disabled = false;
    }

    function addToCart() {
      var items = chosen();
      if (items.length < required) {
        return fail(data.keys.bag
          ? 'O kit leva garrafa, tampa, BottleBag, BottleSleeve e stickers — escolha os cinco.'
          : 'O kit leva garrafa, tampa, BottleSleeve e stickers — escolha os quatro.');
      }

      var unavailable = items.filter(function (i) { return !i.available; });
      if (unavailable.length) return fail('“' + unavailable[0].name + '” está esgotado. Escolha outra opção.');

      errorEl.hidden = true;
      addBtn.disabled = true;
      addLabel.textContent = 'Adicionando…';

      var bundleId = 'kit-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
      /* Só properties OCULTAS (prefixo _): não aparecem pro cliente no carrinho/
         checkout, mas ficam no pedido pro time saber que é kit. */
      var shared = { '_kit': data.kitLabel, '_bundle_id': bundleId };
      /* modo de teste da Function: só linhas com esta property ganham o desconto
         enquanto o `require_flag` do metafield estiver ligado */
      if (data.pricingFlag) shared['_kit_pricing'] = data.pricingFlag;

      /* vai pro carrinho a variante GÊMEA quando existe (preço do kit gravado,
         sem desconto); senão a original */
      var idOf = function (i) { return i.twin || i.id; };
      var bottle = items[0];
      var extras = items.slice(1).map(function (i) {
        return { id: idOf(i), quantity: 1, properties: shared };
      });

      /* Gravação começada mas incompleta: o painel diz o que falta e o kit
         espera — mandar a garrafa lisa em silêncio perderia o pedido do cliente. */
      var g = engraving();
      if (g && g.iniciado && !g.pronto) {
        if (g.avisar) g.avisar();
        return fail('Termine a personalização da garrafa (ou remova a gravação) para adicionar o kit.');
      }

      var bottleStep;
      if (g && g.iniciado) {
        /* O painel adiciona a garrafa com a prévia e o arquivo de gravação,
           já na variante gêmea e com o `_bundle_id`; o carrinho abre no fim. */
        addLabel.textContent = 'Gerando sua gravação…';
        bottleStep = Promise.resolve().then(function () {
          return g.adicionar({ variantId: idOf(bottle), properties: shared, abrirCarrinho: false });
        });
      } else {
        bottleStep = json('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: idOf(bottle), quantity: 1, properties: shared }] })
        });
      }

      bottleStep
        .then(function () {
          return json('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: extras })
          });
        })
        .then(applyDiscount)
        .then(function () {
          addLabel.textContent = 'Kit adicionado ✓';
          openCartDrawer();
          window.setTimeout(function () {
            addLabel.textContent = addLabelText;
            addBtn.disabled = false;
          }, 1800);
        })
        .catch(function (err) {
          fail(err.message || 'Erro ao adicionar ao carrinho');
        });
    }

    /* O Shopify gera `template-page` no body (trunca o sufixo do template),
       então o CSS do kit se apoia nesta classe. */
    document.body.classList.add('tuyo-kit-page');

    addBtn.addEventListener('click', addToCart);

    /* Atalhos do banner (`data-tb-scroll-to="<chave>"`): rolam até o cabeçalho
       do passo, descontando o header fixo. */
    document.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-tb-scroll-to]') : null;
      if (!btn) return;
      var head = document.querySelector('[data-tb-step-for="' + btn.getAttribute('data-tb-scroll-to') + '"]');
      if (!head) return;
      var header = document.querySelector('.site-header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 12;
      window.scrollTo({ top: head.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    });

    /* Um texto solto "avaliação/avaliações" (string de i18n da Judge.me) cai
       direto no <body> e aparece acima do rodapé. Some só nesta página. */
    [].slice.call(document.body.childNodes).forEach(function (node) {
      if (node.nodeType === 3 && /avalia/.test(node.textContent)) node.parentNode.removeChild(node);
    });

    pairGroups();
    paintCapPrices();
    movePersonalizer();
    watch();
    render();

    /* O botão estático sai quando o React assume e o painel pode chegar
       depois do boot: vigiamos até o container estar no slot. */
    var moveObserver = new MutationObserver(function () {
      movePersonalizer();
      var slot = document.querySelector('[data-tb-perso-slot]');
      var panel = document.getElementById('flask-configurator');
      if (slot && panel && slot.contains(panel) && panel.children.length) moveObserver.disconnect();
    });
    moveObserver.observe(document.body, { childList: true, subtree: true });

    /* O painel troca de estado (modo, texto, confirmação) sem mexer em input
       observável de fora — o ✓ do passo é conferido num intervalo curto. */
    var lastLabel = null;
    window.setInterval(function () {
      var label = engravingLabel();
      if (label !== lastLabel) { lastLabel = label; render(); }
    }, 500);
    /* os forms do tema montam depois; uma 2ª leitura evita barra zerada */
    window.setTimeout(function () { pairGroups(); movePersonalizer(); render(); }, 1200);
  }

  function boot() {
    document.querySelectorAll('[data-tuyo-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector('[data-tuyo-bundle]');
    if (node) init(node);
  });
})();
